import React, { useContext, useState } from "react"
import tw, { css } from "twin.macro"
import { useStaticQuery, graphql, navigate } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

import { Button, Container } from "./auvelity-ui"
import { myContext } from "../context/Provider"

import navIcon1 from "../images/slides/navIcon1.svg"
import navIcon2 from "../images/slides/navIcon2.svg"
import navIcon3 from "../images/slides/navIcon3.svg"
import slideIcon4 from "../images/slides/slideIcon-4.svg"
import slideIcon5 from "../images/slides/slideIcon-5.svg"
import slideIcon6 from "../images/slides/slideIcon-6.svg"
import slideIcon7 from "../images/slides/slideIcon-7.svg"

import icon1 from "../images/shapes/grey-oval.svg"
import icon3 from "../images/shapes/yellow-split-square.svg"
import icon5 from "../images/shapes/grey-rectangle-rounded.svg"
import icon7 from "../images/shapes/yellow-triangle.svg"
import icon8 from "../images/shapes/grey-rectangle.png"
import icon9 from "../images/shapes/yellow-rectangle-rounded.svg"
import icon10 from "../images/shapes/geo-triangle-blue-tl.svg"
import triangleBlueBR from "../images/shapes/geo-triangle-blue-br.svg"
import icon11 from "../images/shapes/geo-square-blue.svg"
import icon12 from "../images/shapes/grey-rectangle-rounded-bl.svg"
import icon13 from "../images/shapes/geo-square-yellow.svg"

import VideoOverlay from "./video-overlay"

const PatientContent = () => {
  const context = useContext(myContext);
  const [isOverlayVisible, setOverlayVisible] = useState(false);
  const [videoId, setVideoId] = useState("");
  const { meccaSlide, ryan, danielle, cindy, cindyMobile } =
    useStaticQuery(graphql`
      query {
        meccaSlide: file(relativePath: { eq: "slides/mecca.png" }) {
          childImageSharp {
            gatsbyImageData(width: 600, placeholder: NONE)
          }
        }
        ryan: file(relativePath: { eq: "slides/ryan.png" }) {
          childImageSharp {
            gatsbyImageData(width: 600, placeholder: NONE)
          }
        }
        danielle: file(relativePath: { eq: "slides/danielle.png" }) {
          childImageSharp {
            gatsbyImageData(width: 600, placeholder: NONE)
          }
        }
        cindy: file(relativePath: { eq: "slides/cindy.png" }) {
          childImageSharp {
            gatsbyImageData(width: 600, placeholder: NONE)
          }
        }
      }
    `)

  const data = [
    {
      title: <>Mecca is getting back to basking in&nbsp;the&nbsp;sun</>,
      navTitle: "About",
      image: meccaSlide,
      copy: (
        <>
          For Mecca, depression felt like an endless dark cloud hanging over her head. With AUVELITY, the clouds have begun to part, and she's getting back to enjoying the thing she loves most—long days at the beach.
        </>
      ),
      button: "Watch Mecca's story",
      url: "1039031274",
      buttonTwo: "Read Mecca's story",
      urlTwo: "/mecca",
      icon: slideIcon4,
      navIcon: navIcon1,
      bgicons: [triangleBlueBR, icon5, icon11],
      background: "blue",
      alt: `"It's okay to ask for help." Mecca. Taking AUVELITY since 2023.`
    },
    {
      title: <>Ryan is finding her rhythm&nbsp;again</>,
      image: ryan,
      copy: (
        <span tw="letter-spacing[-0.4px] xl:(kerning[1] block w-full)">
          For Ryan, depression felt like a broken piece of music that threw her off her rhythm. But with AUVELITY, she's beginning to put off-key notes back into tune.
        </span>
      ),
      button: "Watch Ryan's story",
      url: "1039027385",
      buttonTwo: "Read Ryan's story",
      addClassForGTM: "button-one",
      urlTwo: "/ryan",
      navIcon: navIcon2,
      icon: slideIcon5,
      alternative: "alternative",
      bgicons: [icon1, icon13, icon3, icon5],
      actorPortrayal: false,
      alt: "Ryan. Taking AUVELITY since 2022."
    },
    {
      title: <>Danielle is starting to win&nbsp;again</>,
      image: danielle,
      copy: (
        <>
          Danielle battles with depression every day, and she needs support. Now she has AUVELITY in her corner and is starting to put depression on the ropes.
        </>
      ),
      button: "Watch Danielle's story",
      url: "1039025338",
      buttonTwo: "Read Danielle's story",
      urlTwo: "/danielle",
      navIcon: navIcon3,
      icon: slideIcon6,
      addClassForGTM: "",
      bgicons: [icon1, icon13, icon3, icon12],
      actorPortrayal: true,
      background: "blue",
      alt: "Danielle. Taking AUVELITY since 2023."
    },
    {
      title: <>Cindy is beginning to build a brighter&nbsp;future</>,
      image: cindy,
      copy: (
        <>
          Depression left Cindy feeling disconnected from the people she loved the most—like her husband. With AUVELITY, she is starting to build the bright future they always wanted.
        </>
      ),
      button: "Watch Cindy's story",
      url: "1039022752",
      buttonTwo: "Read Cindy's story",
      urlTwo: "/cindy",
      alternative: "alternative",
      navIcon: navIcon3,
      icon: slideIcon7,
      bgicons: [icon8, icon9, icon7, icon5],
      addClassForGTM: "button-one",
      actorPortrayal: false,
      alt: "Cindy. Taking AUVELITY since 2023.",
    },
  ]

  const openVideo = (id) => {
    setVideoId(id);
    setOverlayVisible(true);
  };

  return (
    <div tw="bg-white" id="real-patients">
      <div tw="mt-[-60px] overflow-hidden rounded-tl-[64px] rounded-br-[64px] lg:(mt-[-100px] rounded-none) relative">
        {data.map((item, index) => {
          const alternate = index % 2 === 1;

          return (
            <div className="real-patient-section">
            <section
              key={index}
              css={[
                tw`lg:py-0`,
                alternate ? tw`bg-blue text-white` : tw`bg-white text-[#404040]`,
                index === 0 && tw`rounded-none`,
                index === 1 && tw`rounded-tr-[50px]`,
                index === 2 && tw`rounded-tl-[50px] rounded-br-[50px]`,
                index === 3 && tw`rounded-bl-[50px]`,
              ]}
            >
              <Container>
                <div
                  css={[
                    tw`flex flex-col w-full items-center text-center pt-6 pb-6 lg:(h-full text-left py-0 flex-row justify-between transition invisible opacity-0 transform translate-y-10 duration-200)`,
                    index === index &&
                      tw`lg:(visible opacity-100 translate-y-0 duration-500)`,
                  ]}
                >
                  <div
                    className="content-container"
                    css={[
                      tw`w-full min-h-full flex flex-col justify-start items-center relative py-1 lg:(justify-center items-start px-1 pr-24)`,
                      alternate && tw`lg:order-2`,
                    ]}
                  >
                    <img src={item.icon} className="slide-highlight" css={tw`mb-2 self-start`} alt=""/>
                    <h2
                      css={[
                        tw`text-2xl text-center text-blue font-bold leading-tight mb-1 text-left lg:(mt-0 text-4xl mb-4)`,
                        alternate && tw`text-yellow`,
                      ]}
                    >
                      {item.title}
                    </h2>
                    <p
                      css={[
                        tw`mb-0 px-2 text-left px-0 mt-5 lg:(mt-0 mb-4) xl:(text-lg mb-8)`,
                      ]}
                    >
                      {item.copy}
                    </p>
                    {item.button && !context.isMobile && (
                      <Button
                        arrow={true}
                        variant={alternate ? "blue" : "yellow"}
                        env={"yellow"}
                        onClick={() => openVideo(item.url)}
                        addClassForGTM={item.addClassForGTM + " alternative button-one"}
                        styles={[tw`width[320px]`]}
                      >
                        {item.button}
                      </Button>
                    )}
                    {item.buttonTwo && !context.isMobile && (
                      <Button
                        arrow={true}
                        variant="white"
                        env={"blue"}
                        onClick={() => navigate(item.urlTwo)}
                        addClassForGTM={item.alternative + " button-two"}
                        styles={[tw`width[320px]`]}
                      >
                        {item.buttonTwo}
                      </Button>
                    )}
                  </div>
                  <div
                    css={[
                      tw`relative w-full px-4 lg:(mr-0 px-0 pt-14) md:text-center`,
                      alternate && tw`lg:(order-1 pr-24 pt-14)`,
                    ]}
                  >
                    <GatsbyImage
                      image={getImage(item.image)}
                      alt={item.alt}
                      css={[tw`mb-8 lg:mt-0`]}
                      objectFit="contain"
                      className="patient-image"
                    />
                  </div>
                  <div css={[tw`pb-4`]} className="mobile-button-center">
                    {item.button && context.isMobile && (
                      <Button
                        arrow={true}
                        variant={"blue"}
                        env={"blue"}
                        onClick={() => openVideo(item.url)}
                        addClassForGTM={item.addClassForGTM + " alternative button-one"}
                        styles={[tw`width[320px]`]}
                      >
                        {item.button}
                      </Button>
                    )}
                    {item.buttonTwo && context.isMobile && (
                      <Button
                        arrow={true}
                        variant="white"
                        env={"blue"}
                        onClick={() => navigate(item.urlTwo)}
                        addClassForGTM={item.alternative + " button-two"}
                        styles={[tw`width[320px]`]}
                      >
                        {item.buttonTwo}
                      </Button>
                    )}
                  </div>
                </div>
              </Container>
            </section>
            </div>
          );
        })}
      </div>
      {isOverlayVisible && (
        <VideoOverlay videoId={videoId} onClose={() => setOverlayVisible(false)} />
      )}
    </div>
  );
}

export default PatientContent
